export enum ReleaseStage {
  local = 'local',
  uat = 'UAT',
  prod = 'PROD',
}

export interface Features {
  mockBackEnd: boolean;
}

export interface Environment {
  bugsnagApiKey: string;
  defaultLanguage: string;
  googleAnalyticsId: string;
  features: Features;
  oldProgramUrl: string;
  production: boolean;
  releaseStage: ReleaseStage;
  serverUrl: string;
  supportedLanguages: string[];
  viaSurveyApiKey: string;
  version: string | null;
}
